import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getRoles, deleteRole, changeRoleStatus } from "../api/roleApi";
import { confirmDialog } from "../utils/alert";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";

export default function RolesList() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const loadRoles = async () => {
    setLoading(true);
    try {
      const res = await getRoles({ page, per_page: perPage });
      setRoles(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRoles();
  }, [page, perPage]);

  const handleDelete = async (id) => {
    const confirmed = await confirmDialog({ text: "Delete this role?" });
    if (!confirmed) return;
    await deleteRole(id);
    loadRoles();
  };

  const handleToggleActive = async (role) => {
    await changeRoleStatus(role.id, !role.is_active);
    loadRoles();
  };

  return (
    <AdminLayout title="Roles">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title mb-0">Role List</h5>
            <button
              className="btn skedq-accent-btn"
              onClick={() => navigate("/roles/new")}
            >
              Add New Role
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="6" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && roles.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No roles found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  roles.map((r, index) => (
                    <tr key={r.id}>
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td>{r.role_name}</td>
                      <td>{r.category}</td>
                      <td>
                        <span
                          className={
                            "badge " +
                            (r.is_active ? "bg-success" : "bg-secondary")
                          }
                        >
                          {r.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => navigate(`/roles/edit/${r.id}`)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => handleToggleActive(r)}
                          >
                            {r.is_active ? "Deactivate" : "Activate"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(r.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
